import React from "react";
import styles from "./index.module.scss";
import moment from "moment";
import { formatAbbreviatedCurrency } from "../../../../utils/utils";

type PreItem = {
  id?: string | number;
  street?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  postalcode?: string;
  address?: string;
  fullAddress?: string;
  askingPrice?: number;
  salePrice?: number; 
  purchasePrice?: number;
  currentSaleRecordingDate?: string; 
  prevSaleRecordingDate?: string;
  saleDate?: string; 
  purchaseDate?: string;
  date?: string;
};

const parseYMD = (ymd?: string) => {
  if (!ymd) return undefined;
  if (/^\\d{8}$/.test(ymd)) {
    const y = ymd.slice(0, 4);
    const m = ymd.slice(4, 6);
    const d = ymd.slice(6, 8);
    return `${y}-${m}-${d}`;
  }
  return ymd;
};

const fmtDate = (val?: string) => {
  if (!val) return "--";
  return moment(val).format("DD MMM YYYY");
};

const buildAddress = (it: PreItem) => {
  if (it.address) return it.address;
  if (it.fullAddress) return it.fullAddress;
  const parts = [
    it.street,
    [it.city, it.state].filter(Boolean).join(", "),
    it.postalCode || it.postalcode
  ].filter(Boolean);
  return parts.join(", ");
};

export default function PreListCards({ data = [] as PreItem[] }: { data?: PreItem[] }) {
  return (
    <div className={styles.preCardsWrap}>                                                                                                                 
      {data.map((item, idx) => {
        const salePrice = typeof item.salePrice === "number" ? item.salePrice : item.askingPrice;
        const purchasePrice = item.purchasePrice;
        const saleDate = parseYMD(item.currentSaleRecordingDate) ?? item.saleDate ?? item.date;
        const purchaseDate = parseYMD(item.prevSaleRecordingDate) ?? item.purchaseDate;
        return (
          <div
            key={`${item.id ?? item.address ?? item.fullAddress ?? "pre"}-${idx}`}
            className={styles.card}
          >
            <div className={styles.address}>{buildAddress(item)}</div>
            <div className={styles.stats}>
              <div className={styles.col}>
                <span className={styles.label}>Sale Price</span>
                <span className={styles.value}>
                  {typeof salePrice === "number" ? formatAbbreviatedCurrency(salePrice, "USD") : "--"}
                </span>
                <span className={styles.label}>Sale Date</span>
                <span className={styles.date}>{fmtDate(saleDate)}</span>
              </div>
              <div className={styles.col}>
                <span className={styles.label}>Purchase Price</span>
                <span className={styles.value}>
                  {typeof purchasePrice === "number"
                    ? formatAbbreviatedCurrency(purchasePrice, "USD")
                    : "--"}
                </span>
                <span className={styles.label}>Purchase Date</span>
                <span className={styles.date}>{fmtDate(purchaseDate)}</span>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}


